import type { Icon } from "@/components/icons";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type OrderSectionProps = {
  icon?: Icon;
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function ProductFormSectionLike({
  icon: IconComponent,
  title,
  description,
  action,
  children,
  className,
}: OrderSectionProps) {
  return (
    <section
      className={cn("brand-card flex flex-col gap-4 p-5 sm:p-6", className)}
    >
      <div className="flex flex-col gap-3 border-secondary/20 border-b pb-4 sm:flex-row sm:flex-wrap sm:items-start sm:justify-between">
        <div className="flex items-start gap-3">
          {IconComponent ? (
            <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/20 text-secondary">
              <IconComponent />
            </div>
          ) : null}
          <div className="flex flex-col gap-0.5">
            <h3 className="font-display text-foreground text-lg leading-tight">
              {title}
            </h3>
            {description ? (
              <p className="text-muted-foreground text-sm">{description}</p>
            ) : null}
          </div>
        </div>
        {action ? <div className="w-full sm:w-auto sm:shrink-0">{action}</div> : null}
      </div>
      {children}
    </section>
  );
}
